import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "property-peek-fields"
}

import { computed, inject, ref, watch } from "vue";
import modalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { PropertySummary } from "@/types/properties/PropertySummary";
import AcquaintInfoBox from "../ui/inputs/acquaint-info-box.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'property-peek-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the property.
   * @type {number}
   * @required
   */
  propertyId: {
    type: Number,
    required: true,
  },
  /**
   * The title or heading associated with the component.
   * @type {string}
   * @default: 'Property Peek'
   */
  title: {
    type: String,
    default: "Property Peek",
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;

const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const propertySummary = ref<PropertySummary>();





const showPeek = computed({
  get: () => props.modelValue,
  set: (value: Boolean) => emit("update:modelValue", value),
});

const closePeek = () => {
  showPeek.value = false;
};

// When the peek popup is visible, the data is fetched
watch(
  () => showPeek.value,
  async () => {
    if (!showPeek.value) {
      return;
    }

    await getPropertyData();
  },
);

const getPropertyData = async () => {
  try {
    propertySummary.value = await apiClient.httpGet(
      `app/properties/${props.propertyId}/summary`,
    );
  } catch (ex) {
    displayErrorMessage(getErrorMessage(ex));
    propertySummary.value = undefined;
  }
};

const sendEmail = () => {
  window.open(`mailto:${propertySummary.value?.address}`);
};

const callTelephone = () => {
  window.open(`tel:${propertySummary.value?.owner.telephoneNumber}`);
};

const callMobile = () => {
  window.open(`tel:${propertySummary.value?.owner.telephoneNumber}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(modalBase, {
    title: "",
    modelValue: showPeek.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showPeek).value = $event)),
    showCloseButton: true,
    height: "530px"
  }, {
    "main-title": _withCtx(() => [
      _createTextVNode(_toDisplayString(props.title), 1)
    ]),
    content: _withCtx(() => [
      (propertySummary.value)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createVNode(AcquaintInfoBox, {
              text: propertySummary.value.category.description,
              label: "Category"
            }, null, 8, ["text"]),
            _createVNode(AcquaintInfoBox, {
              text: propertySummary.value.type.description,
              label: "Type"
            }, null, 8, ["text"]),
            _createVNode(AcquaintInfoBox, {
              text: propertySummary.value.status.description,
              label: "Status"
            }, null, 8, ["text"]),
            _createVNode(AcquaintInfoBox, {
              text: propertySummary.value.owner.name,
              label: "Owner"
            }, null, 8, ["text"]),
            _createVNode(AcquaintInfoBox, {
              text: propertySummary.value.owner.mobileNumber,
              label: "Mobile",
              icon: "tel",
              onIconClicked: callMobile
            }, null, 8, ["text"]),
            _createVNode(AcquaintInfoBox, {
              text: propertySummary.value.owner.telephoneNumber,
              label: "Telephone",
              icon: "tel",
              onIconClicked: callTelephone
            }, null, 8, ["text"]),
            _createVNode(AcquaintInfoBox, {
              text: propertySummary.value.owner.emailAddress,
              label: "Email",
              icon: "email",
              onIconClicked: sendEmail
            }, null, 8, ["text"])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Close',
          onClick: () => {
            closePeek();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})